<template>
  <div
    class="videos-list card is-unselectable"
    :class="{ 'videos-list--dark': dark }"
  >
    <div class="card-header">
      <div class="card-header-title">
        <div class="field has-addons">
          <div
            class="control has-icons has-icons-left"
            :class="{ 'is-loading': isSearching }"
          >
            <input
              type="text"
              class="input is-rounded"
              :class="{ 'query-dsl': search.startsWith('!') }"
              :value="search"
              @input="$emit('update:search', $event.target.value)"
              placeholder="Wyszukaj film..."
            />
            <icon name="fa-search" class="is-left" />
          </div>

          <div class="control" v-if="search.length > 0">
            <button
              class="button is-rounded"
              @click="$emit('update:search', '')"
              data-tooltip="Wyczyść"
            >
              <icon name="fa-trash" />
            </button>
          </div>
        </div>
      </div>
      <div class="card-header-icon">
        <input
          id="switchDarkMode"
          type="checkbox"
          class="switch"
          :checked="dark"
          :value="dark"
          @change="$emit('switch-dark-mode', $event.target.value === 'false')"
        />
        <label for="switchDarkMode">
          <icon name="fa-moon" :class="{ 'has-text-primary': dark }" />
        </label>
      </div>
    </div>
    <div class="card-content">
      <div class="videos-layout columns">
        <div class="is-unselectable column is-narrow">
          <tags-list
            :tags="tags"
            :dark="dark"
            @toggle-tag-selection="$emit('toggle-tag-selection', $event)"
            @clear-selected-tags="$emit('clear-selected-tags')"
          />
        </div>
        <div class="column">
          <loader :state="videosState">
            <template>
              <div class="videos-container" v-if="videos.length > 0">
                <video-item
                  v-for="video in videos"
                  :key="video.id"
                  :video="video"
                  :dark="dark"
                  @click="$emit('select-video', $event)"
                  @click-tag="$emit('select-tag', $event)"
                  tag-clickable
                />
              </div>

              <div class="grey-message" v-else>
                <icon name="fa-search" />
                <p>
                  Nie znaleziono żadnych materiałów spełniających podane
                  kryteria.
                </p>
              </div>
            </template>

            <template #loading>
              <div
                class="spinner is-3by4 is-grey-lighter is-large is-thick is-centered"
              />
            </template>

            <template #error>
              <div class="grey-message">
                <icon name="fa-times-circle" />
                <p>
                  Materiały niedostępne z powodu braku połączenia z serwerem.
                </p>
              </div>
            </template>
          </loader>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper card-footer">
      <pagination
        class="is-centered"
        :pageable="pageable"
        :dark="dark"
        @change-page="$emit('change-page', $event)"
        buttons
      />
    </div>
  </div>
</template>

<script>
import { Icon, Pagination, Loader } from "%helpers";
import TagsList from "./TagsList";
import VideoItem from "./VideoItem";

export default {
  name: "videos-list",

  components: {
    Icon,
    TagsList,
    VideoItem,
    Pagination,
    Loader
  },

  props: {
    tags: Array,
    videos: Array,
    page: Number,
    dark: Boolean,
    search: String,
    pageable: Object,
    isSearching: Boolean,
    videosState: String
  }
};
</script>

<style lang="scss" scoped>
.videos-layout {
  @include mobile {
    flex-direction: column;
    display: flex;
    margin-bottom: 1rem;
  }
}

.pagination-wrapper {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background: $white-ter;
}

.videos-list--dark {
  &.card {
    background: $grey-darker;
    color: $grey;
  }

  .pagination-wrapper {
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background: $black-ter;
  }

  .field {
    .input {
      background: lighten($grey-darker, 5);
      border-color: $grey-dark;
      color: $grey-light;

      &::placeholder {
        color: $grey;
      }

      & ~ .icon {
        color: $grey;
      }

      &:focus ~ .icon {
        color: $grey-light;
      }

      &.query-dsl {
        color: $primary;
      }
    }

    .button {
      background: lighten($grey-darker, 5);
      border-color: $grey-dark;
      color: $grey-light;
    }
  }
}

.query-dsl {
  color: $primary;
}
</style>
